export default function Hero({ t, lang }) {
  return (
        <section className="hero-video d-flex align-items-center">
      
      {/* Vidéo background */}
      <video
        className="hero-video-bg"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src="/videos/hero.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="hero-overlay">
        <div 
                className="hero-image-overlay"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundImage: 'url(/images/losanges.jpg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  opacity: 0.4,
                  zIndex: 1
                }}
        >
        </div>

      </div>

      {/* Contenu */}
      <div className="hero-content">
        <h1 className="hero-title display-1" style={{color:'white', fontFamily:'pangram-eiko-lightItalic'}}>{t("sentence1")}</h1>
      </div>

    </section>
  );
}